<script>
  import Button from "../UI/Button.svelte";
  import { createEventDispatcher } from "svelte";

  const dispatch = createEventDispatcher();
  export let currentPage;
  export let locationSet;
  
  function aboutPage(event) {
    dispatch("updatePage", 'about');
    console.log('about');

  };

  function calendarPage(event) {
    dispatch("updatePage", 'calendar');
    console.log('calendar', locationSet);

  };

  function homePage(event) {
    dispatch("updatePage", 'calendar');
    console.log('home', locationSet);
    

  };

</script>

<header class="wrapper">
  <aside class="aside">
    <span class="left-menu">
      <nav>        
        <Button mode="brand" type="button" on:click={homePage}
        ><a href="/">Clime</a></Button
        >
      </nav>

    </span>
  </aside>

  <aside class="aside">
    <span class="right-menu">
      <nav>        
        <Button mode="nav" type="button" on:click={aboutPage}
        ><a href="/about">About</a></Button
        >
      </nav>
      <!-- <nav>        
        <Button mode="nav" type="button" on:click={boxesPage}
        ><a href="/boxes">Planter Boxes</a></Button
        >
      </nav> -->
    </span>
  </aside>
</header>

<style>
  header {
    margin: 0px;
  }

  header nav {
    display: flex;
    justify-content: right;
    /* row-gap: var(--space-5x); */
    font-size: var(--text-06);
  }

  .wrapper {
    display: flex;
    align-items: baseline;

    flex-flow: row wrap;
    font-weight: bold;
    text-align: left;
    align-content: flex-end;
  }

  .wrapper > * {
    /* padding: 10px; */
    flex: 1 100%;
  }

  .left-menu {
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;
  }

  .right-menu {
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-end;
    gap: var(--space-4x);;
  }

  @media all and (min-width: 600px) {
    .aside {
      flex: 1 0 0;
    }
  }
</style>
